import api, { withLoading } from '@/api/api';

const resource = `v1/ict/clientes`;
const LOADING_KEY = 'ict-clientes';

export default {
    getAll(empresaId, params = {}) {
        const { query } = params;
        return withLoading(LOADING_KEY, () =>
            api.get(`${resource}/${empresaId}${query ? `?${query}` : ""}`).then(res => res.data)
        );
    },
    getOne(empresaId, clienteId) {
        return withLoading(LOADING_KEY, () =>
            api.get(`${resource}/${empresaId}/${clienteId}`).then(res => res.data)
        );
    },
    create(empresaId, data) {
        return withLoading(LOADING_KEY, () =>
            api.post(`${resource}/${empresaId}`, data).then(res => res.data)
        );
    },
    update(empresaId, clienteId, data) {
        return withLoading(LOADING_KEY, () =>
            api.post(`${resource}/${empresaId}/${clienteId}`, data).then(res => res.data)
        );
    },
    delete(empresaId, clienteId) {
        return withLoading(LOADING_KEY, () =>
            api.delete(`${resource}/${empresaId}/${clienteId}`).then(res => res.data)
        );
    }
}
